<template>
  <v-container fluid class="hero-section pa-0">
    <v-row class="hero-content ma-0" align="center" justify="center">
      <v-col cols="12" md="10" lg="8" class="text-center">
        <div class="hero-badge mb-4">
          <v-chip color="#59C8E4" label small class="white--text">
            <v-icon left small>mdi-new-box</v-icon>
            NEW FEATURE
          </v-chip>
        </div>
        
        <h1 class="hero-title mb-4">
          <span class="hero-title-gradient">Automated</span> Purchase Orders
        </h1>
        
        <p class="hero-subtitle mb-8">
          Save 80% of your time with intelligent automation that creates purchase orders 
          based on your inventory needs. Set it up once, and let the system work for you.
        </p>
        
        <div class="hero-actions">
          <v-btn
            x-large
            color="#faaf3b"
            class="hero-btn-primary mr-4 mb-4"
            @click="navigateToSetup"
            elevation="0"
          >
            <v-icon left>mdi-rocket-launch</v-icon>
            Get Started Now
          </v-btn>
        </div>
        
        <div class="hero-stats mt-8">
          <v-row justify="center">
            <v-col cols="6" sm="3" v-for="stat in stats" :key="stat.label">
              <div class="stat-item">
                <div class="stat-value">{{ stat.value }}</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    
    <div class="hero-decoration">
      <div class="decoration-circle decoration-circle-1"></div>
      <div class="decoration-circle decoration-circle-2"></div>
      <div class="decoration-circle decoration-circle-3"></div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      stats: [
        { value: '80%', label: 'Time Saved' },
        { value: '99%', label: 'Accuracy' },
        { value: '24/7', label: 'Automation' },
        { value: '5min', label: 'Setup Time' }
      ]
    }
  },
  methods: {
    navigateToSetup() {
      this.$router.push('/automation-configs')
    }
  }
}
</script>

<style scoped>
.hero-section {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #12222D 0%, #2c4051 100%);
  min-height: 500px;
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 80px 20px;
}

.hero-badge {
  animation: fadeInDown 0.6s ease-out;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  animation: fadeInUp 0.8s ease-out;
}

.hero-title-gradient {
  background: linear-gradient(to right, #faaf3b 0%, #f9d085 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.4rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
  line-height: 1.6;
  max-width: 700px;
  margin: 0 auto;
  animation: fadeInUp 1s ease-out;
}

.hero-actions {
  animation: fadeInUp 1.2s ease-out;
}

.hero-btn-primary {
  background: linear-gradient(45deg, #faaf3b 30%, #f9d085 90%);
  border: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 5px 2px rgba(250, 175, 59, .3);
}

.hero-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px 4px rgba(250, 175, 59, .3);
}


.hero-stats {
  animation: fadeInUp 1.4s ease-out;
}

.stat-item {
  text-align: center;
  color: white;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 8px;
  background: linear-gradient(to bottom, #ffffff 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.8;
}

.hero-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(89, 200, 228, 0.1);
  animation: float 20s infinite ease-in-out;
}

.decoration-circle-1 {
  width: 300px;
  height: 300px;
  top: -150px;
  right: -150px;
  animation-delay: 0s;
}

.decoration-circle-2 {
  width: 200px;
  height: 200px;
  bottom: -100px;
  left: -100px;
  animation-delay: 7s;
}

.decoration-circle-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  left: 10%;
  animation-delay: 14s;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

@media (max-width: 960px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
  
  .hero-content {
    padding: 60px 20px;
  }
  
  .stat-value {
    font-size: 2rem;
  }
}
</style> 